var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "156.95 68.24 152.01 190.44 66.69 190.44 59.9 67.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.94 48.38 45.94 67.64 169.32 67.64 169.32 48.38 158.65 48.38 149.31 31.04 67.95 31.04 58.61 48.38 45.94 48.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.49,131.64H90.58a19.23,19.23,0,0,0,35.41,0h28.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.38,116.65H126a19.23,19.23,0,0,0-35.41,0H63.49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/COFFEE.a22ec7974da8d8090733eb5b518e58b7.svg";
export { ForwardRef as ReactComponent };